import { BarcodeProposal, BarcodeProposalListResponse } from '@/types/barcodeResolution'
import { defineStore } from 'pinia'

interface States {
  barcodeProposals: Ref<BarcodeProposalListResponse | null>
  barcodeProposal: Ref<BarcodeProposal | null>
}

export const useBarcodeResolutionStore = defineStore('barcodeResolution', () => {
  const states: States = {
    barcodeProposals: ref(null),
    barcodeProposal: ref(null),
  }

  const resetStore = () => {
    states.barcodeProposals.value = null
    states.barcodeProposal.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
